import React from "react"
import { Col, Row, Form, Dropdown } from "react-bootstrap"
import { getIn } from "formik"
import FormLabel from "./formLabel"

function FormDropdownArray(props) {
  const {
    textDesc,
    form,
    field,
    dropdownItem,
    propertyName,
    secondFieldName,
    secondPropertyName,
  } = props

  const errorsMsg = getIn(form.errors, field.name)
  // const touched = getIn(form.touched, field.name)

  const inputErrorMessage = (touched, errors, inputName) => {
    return errors[inputName] && touched[inputName] ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  const DropdownValueChange = (newValue, secondFieldNewValue) => {
    form.setFieldValue(field.name, newValue)
    if (secondFieldName && secondFieldNewValue) {
      form.setFieldValue(secondFieldName, secondFieldNewValue)
    } else if (secondFieldName && !secondFieldNewValue) {
      form.setFieldValue(secondFieldName, "")
    }

    // if (extraFieldValue && affectedField) {
    //   if (extraFieldValue.indexOf(description) !== -1) {
    //     denied = true
    //   }

    //   affectedField.forEach((FieldItem, FieldKey) => {
    //     delete errorsList[FieldItem]
    //     actionList.push(
    //       updateCategoryClaimData(coverageCategory, coverageCode, FieldItem, "")
    //     )
    //     form.setFieldValue(FieldItem, "")
    //   })
    // }
  }

  return (
    <div className="marginBottom19px">
      <FormLabel text={textDesc} />
      <div className="marginTop10px">
        <Dropdown className="dropdown">
          <Dropdown.Toggle className="btn btn-secondary dropdown-toggle DropdownHeader borderRadius8">
            {field.value}
            {/* {dropDownValue} */}
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-menu DropdownMenu">
            {dropdownItem.map((item, key) => (
              <React.Fragment key={key}>
                <Dropdown.Item
                  onClick={event => {
                    form.handleChange(event)

                    DropdownValueChange(
                      item[propertyName],
                      item[secondPropertyName]
                    )
                  }}
                >
                  {item[propertyName]}
                </Dropdown.Item>
                <Dropdown.Divider />
              </React.Fragment>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        {/* {errors && touched && <span className="InputError">{errors}</span>} */}
        {/* <span className="InputError">{errors}</span> */}
        {inputErrorMessage(form.touched, form.errors, field.name)}
      </div>
    </div>
  )
}

export default FormDropdownArray
